module.exports = __webpack_public_path__ + "static/img/问煤.32712a35.png";